import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BsCalendar3 } from "react-icons/bs"
import { AiFillTag } from "react-icons/ai"

const NewsFeaturedHero = () => {
  const { allStrapiArticle, allStrapiCategory } = useStaticQuery(graphql`
    {
      allStrapiArticle(filter: { isFeaturedHero: { eq: true } }, limit: 1) {
        nodes {
          id
          slug
          title
          description
          subtitle
          date
          cover {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
          }
        }
      }
      allStrapiCategory(
        filter: { articles: { elemMatch: { isFeaturedHero: { eq: true } } } }
      ) {
        nodes {
          slug
          name
        }
      }
    }
  `)

  const featuredHero = allStrapiArticle.nodes
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  return (
    <>
      {featuredHero?.map((blog, index) => {
        const pathToImage = getImage(blog.cover.localFile)
        const publishDate = new Date(blog.date)?.toLocaleDateString(
          "es-MX",
          options
        )
        return (
          <div
            key={index}
            className="card"
          >
            <Link to={`/blog/${blog.slug}`}>
              <div className="card-image">
                <GatsbyImage
                  image={pathToImage}
                  alt={blog.cover.alternativeText}
                />
              </div>
            </Link>
            <div className="card-info">
              <h2 className="card-title">{blog.title}</h2>
              <div className={`show description`}>
                <p className="card-body">{blog.description}</p>
                <div className="ref">
                  <Link to={`/blog/${blog.slug}`}>
                    <div className="button">Leer Más</div>
                  </Link>
                </div>
                <div className="card-info-bottom">
                  <div className="tag">
                    <AiFillTag className="tag-icon" />
                    <span>{allStrapiCategory?.nodes[0]?.name}</span>
                  </div>
                  <div className="date">
                    <BsCalendar3 className="date-icon" />
                    <span>{publishDate}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default NewsFeaturedHero
